import $ from "jquery";
import { bindButtonClick } from "./buttonbind";
import Plyr from "plyr";
/* eslint-disable */
export default function filters() {
  $(".filter a").on("click", function () {
    var $type = $(this).attr("data-type");
    var $post = $(this).attr("data-post");
    $(".filter a.active").removeClass("active");
    $(this).addClass("active");

    $(".loading").fadeIn();
    $.ajax({
      url: ajax_object.ajax_url,
      data: {
        action: "get_ajax_posts",
        type: $type,
        post: $post,
      },
      type: "POST",
      success: function (response) {
        $(".posts-container").html(response);
        $(".loading").fadeOut();
        bindButtonClick();
      },
    });
  });

  $(".travel-filter a").on("click", function () {
    var $type = $(this).attr("data-type");
    $(".travel-filter a.active").removeClass("active");
    $(this).addClass("active");

    $(".loading").fadeIn();
    $.ajax({
      url: ajax_object.ajax_url,
      data: {
        action: "get_travel_info",
        type: $type,
      },
      type: "POST",
      success: function (response) {
        $(".travel-information-output").html(response);
        $(".loading").fadeOut();
        bindButtonClick();
      },
    });
  });

  $(".filters-popout input").change(function () {
    $.fn.filter();
  });

  $(".testimonials-filters-popout input").change(function () {
    $.fn.testimonialsfilter();
  });

  $("#layout a").on("click", function () {
    $("#layout a").removeClass("active");
    $(this).addClass("active");
    $.fn.filter();
  });

  $('input[name="custom_duration"], input[name="weeks"]').on(
    "click",
    function () {
      if (
        $(this).hasClass("clicked-weeks") ||
        $(this).hasClass("clicked-custom")
      ) {
        if ($(this).hasClass("clicked-weeks")) {
          $(this).removeClass("clicked-weeks");
        } else {
          $(this).removeClass("clicked-custom");
        }
      } else {
        if ($(this).attr("name") === "custom_duration") {
          $('input[name="weeks"]').removeClass("clicked-weeks");
          $(this).addClass("clicked-custom");
        } else {
          $('input[name="custom_duration"]').removeClass("clicked-custom");
          $(this).addClass("clicked-weeks");
        }
      }
    }
  );

  $.fn.extend({
    filter: function () {
      var $count = 0;
      var $weeks = [];
      var $location = [];
      var $ability = [];
      var $level = [];
      var $details_styles = [];
      var $custom_durations = [];
      var $active = "";
      var $resort = "";
      var $layout = "";
      var $cat = $("#category").attr("data-type");

      if (
        $('input[name="custom_duration"].clicked-custom:checked').length > 0
      ) {
        $('input[name^="weeks"]').prop("checked", false);
      }
      if ($('input[name="weeks"].clicked-weeks:checked').length > 0) {
        $('input[name^="custom_duration"]').prop("checked", false);
      }

      if ($(".destination-id")[0]) {
        $resort = $(".destination-id").text();
      } else {
        $resort = "";
      }

      $layout = $("#layout a.active").attr("data-type");

      $('input[name="weeks"]:checked').each(function () {
        $weeks[$count] = this.value;
        console.log(this.value);
        $count++;
      });

      $('input[name="custom_duration"]:checked').each(function () {
        $custom_durations[$count] = this.value;
        console.log(this.value);
        $count++;
      });

      $count = 0;

      $('input[name="location"]:checked').each(function () {
        $location[$count] = this.value;
        console.log(this.value);
        $count++;
      });

      $count = 0;

      $('input[name="ability"]:checked').each(function () {
        $ability[$count] = this.value;
        console.log(this.value);
        $count++;
      });

      $count = 0;

      $('input[name="level"]:checked').each(function () {
        $level[$count] = this.value;
        console.log(this.value);
        $count++;
      });

      $('input[name="details_style"]:checked').each(function () {
        $details_styles[$count] = this.value;
        console.log(this.value);
        $count++;
      });
      $(".loading").fadeIn();
      $(".courses-container").css("opacity", 0);
      $.ajax({
        url: ajax_object.ajax_url,
        data: {
          action: "get_ski_posts",
          weeks: $weeks,
          custom_durations: $custom_durations,
          location: $location,
          ability: $ability,
          level: $level,
          details_styles: $details_styles,
          resort: $resort,
          cat: $cat,
          layout: $layout,
        },
        type: "POST",
        success: function (response) {
          $(".courses-container").html(response);
          $("#course-count").text($count);
          $active = $(".switcher a.active").attr("data-type");
          $("." + $active + "-courses-container").addClass("active");
          $(".courses-container").css("opacity", 1);
          var $numItems = $(
            ".courses-wrapper.active .single-course-item"
          ).length;
          if ($numItems == 1) {
            $("#course-plural").hide();
          } else {
            $("#course-plural").show();
          }
          $("#course-count").text($numItems);
          $("#ski-count").text($count);
          $(".loading").fadeOut();
        },
      });
    },

    testimonialsfilter: function () {
      var $count = 0;
      var $resort = [];
      var $course = [];

      // if ($(".destination-id")[0]){
      //     $resort = $(".destination-id").text();
      // } else {
      //     $resort = "";
      // }

      $('input[name="resort"]:checked').each(function () {
        $resort[$count] = this.value;
        console.log(this.value);
        $count++;
      });

      $count = 0;

      $('input[name="course"]:checked').each(function () {
        $course[$count] = this.value;
        console.log(this.value);
        $count++;
      });

      $count = 0;

      console.log($resort);
      console.log($course);
      $(".loading").fadeIn();
      $(".testimonials-container").css("opacity", 0);
      $.ajax({
        url: ajax_object.ajax_url,
        data: {
          action: "get_testimonials",
          resort: $resort,
          course: $course,
        },
        type: "POST",
        success: function (response) {
          $(".testimonials-container").html(response);
          $(".testimonials-container").css("opacity", 1);
          const players = Array.from(document.querySelectorAll(".player")).map(
            (p) =>
              new Plyr(p, {
                autoplay: false,
                controls: ["play-large"],
              })
          );
          $(".loading").fadeOut();
        },
      });
    },
  });

  //on load
  $("#grid").trigger("click");

  $("#collective-load").on("click", function () {
    var $id = $(".collective-id").attr("id");
    var $start = $("#collective-load").attr("num-low");
    var $max = $("#collective-load").attr("num-high");
    var $count = $("#count").attr("count");
    var $collective_id_array = [];
    $(".js-collective-item").each(function (index) {
      var $collective_item_id = $(this).attr("id");
      $collective_id_array.push($collective_item_id);
    });
    $("#collective-load .loader").css({ opacity: 1 });
    $.ajax({
      url: ajax_object.ajax_url,
      data: {
        action: "load_collective",
        id: $id,
        start: $start,
        max: $max,
        loaded_posts: $collective_id_array,
      },
      type: "POST",
      success: function (response) {
        $(response).appendTo(".posts-container");
        bindButtonClick();
        $(".post-block").slideDown({
          duration: 3000,
          start: function () {
            $(this).css({
              display: "flex",
            });
          },
        });
        $("#collective-load .loader").css({ opacity: 0 });
        bindButtonClick();
        if ($count <= $max) {
          $("#collective-load").removeClass("cursor-pointer");
          $("#collective-load").text("You've reached the end");
        }
      },
    });

    $start = parseInt($start) + 15;
    $max = parseInt($max) + 15;

    $("#collective-load").attr("num-low", $start);
    $("#collective-load").attr("num-high", $max);
  });

  $("a.date-filter").on("click", function () {
    if ($(this).hasClass("active")) {
    } else {
      if ($(this).hasClass("season")) {
        $("a.date-filter.season.active").removeClass("active");
      } else if ($(this).hasClass("weeks")) {
        $("a.date-filter.weeks.active").removeClass("active");
      }
      $(this).addClass("active");
      var $season = $("a.date-filter.season.active").attr("data-type");
      var $weeks = $("a.date-filter.weeks.active").attr("data-type");
      var $id = $("a.date-filter.season.active").attr("data-id");

      $.ajax({
        url: ajax_object.ajax_url,
        data: {
          action: "get_course_dates",
          season: $season,
          weeks: $weeks,
          id: $id,
        },
        type: "POST",
        success: function (response) {
          $(".dates-container").html(response);
          //$('.loading').fadeOut();
        },
      });
    }
  });
}
